import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./footer.module.css";

function Footer(props) {
  return (
    <footer
      className={
        ` ${styles.footerpadding} ` + (props.default ? " footer-default" : "")
      }
      style={{
        marginTop: "auto",
        backgroundColor: "#f4f3ef",
        borderTop: "1px solid #ddd",
      }}
    >
      <div className={styles.footer_text}>
        <div className="footer-nav">
          <div className="text-secondary">
            &copy; {new Date().getFullYear()} Principally LLC. All Rights Reserved.
          </div>
        </div>
        <div className={styles.footer_link}>
          <Link to="/faq" className={styles.link_hover}>
            FAQ
          </Link>
          <a
            href="https://forms.gle/QN892MB9WXtK3Epu8"
            className={styles.link_hover}
            target="_blank"
            rel="noreferrer"
          >
            Submit Feedback
          </a>
          <Link to="/termsofuse" className={styles.link_hover2}>
            Terms of Use
          </Link>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
